import { Button, Card, Typography, makeStyles, Box } from '@material-ui/core';
import { getCdnUrl, hjTagging, openUpsell } from 'utils';
import { useEffect, useState } from 'react';

import BackgroundBlurImage from 'components/Shared/BackgroundBlurImage';
import { CourseTheme } from 'assets/themes/Course';
import { IUser } from 'interface/user';
import { Upsell } from 'interface/offers';
import UpsellModal from './UpsellModal/UpsellModal';
import { upsSendJudas } from 'actionCreators/judasLog';
import upsellFallbackImage from 'assets/img/nutror-card-upsell.png';
import { useAppSelector } from 'hooks/redux';
import useImageFallback from 'hooks/useImageFallback';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  card: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  upsellContainer: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down(780)]: {
      flexDirection: 'column',
    },
  },
  title: {
    fontWeight: 700,
    height: '30px',
  },
  image: {
    position: 'relative',
    overflow: 'hidden',
    width: '346px',
  },
  newImage: {
    maxWidth: '346px',
    position: 'relative',
    maxHeight: '148px',
    overflow: 'hidden',
    width: 200,
    marginRight: theme.spacing(4),
  },
  description: {
    maxWidth: '390px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    webkitOverflowScrolling: 'touch',
    '& button': {
      maxWidth: 'fit-content',
    },
    '& p': {
      wordBreak: 'break-word',
    },
    [theme.breakpoints.down(780)]: {
      marginTop: theme.spacing(2),
    },
  },
  descriptionText: {
    height: 67,
    overflowX: 'hidden',
    marginBottom: theme.spacing(4),
    '&::-webkit-scrollbar': {
      webkitApearance: 'none',
      width: 10,
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.grey[200],
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.grey[400],
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.grey[600],
    },
  },
  photo: {
    overflow: 'hidden',
    '& img': {
      width: '205px',
      [theme.breakpoints.down(780)]: {
        width: '296px',
      },
    },
    [theme.breakpoints.up(780)]: {
      marginRight: theme.spacing(5),
    },
  },
  moreDetails: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down(780)]: {
      marginLeft: '0px',
    },
  },
  actionBar: {
    [theme.breakpoints.down(780)]: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
    },
  },
}));

const UpsellCard = (props: Upsell) => {
  const classes = useStyles();
  const [showDetails, setShowDetails] = useState(false);
  const user = useAppSelector((state) => state.user as IUser);
  const { id, content, producer_id, showcase_image, title, label_text, description, small_image } = props;
  const imageProps = useImageFallback(small_image, upsellFallbackImage);

  const openOffer = (e: any) => {
    hjTagging('AULA-CLICOU-UPSELL');
    upsSendJudas({
      action: 'click',
      id,
      hash_checkout: content,
      viewd: 'page_lesson',
      producer_id,
      user_id: user.id,
    });
    openUpsell(e, props, 'AULA', user);
  };

  useEffect(() => {
    if (!props || !user) return null;
    hjTagging('AULA-EXIBIU-UPSELL');
    upsSendJudas({
      action: 'view',
      id,
      hash_checkout: content,
      viewd: 'page_lesson',
      producer_id,
      user_id: user.id,
    });
  }, [user, props]);

  const showMoreDetails = () => {
    setShowDetails(!showDetails);
  };

  if (!props) return null;

  return (
    <Card variant='outlined' className={classes.card}>
      <section className={classes.upsellContainer}>
        {showcase_image && (
          <section className={classes.photo}>
            <img src={getCdnUrl(showcase_image, upsellFallbackImage)} alt='imagem da oferta da aula' />
          </section>
        )}
        {!showcase_image && (
          <Box className={classes.newImage}>
            <BackgroundBlurImage {...imageProps} alt='imagem da oferta da aula' />
          </Box>
        )}
        <section className={classes.description}>
          <Typography variant='h4' className={classes.title} noWrap>
            {title}
          </Typography>
          <Typography variant='body1' className={classes.descriptionText}>
            {description}
          </Typography>
          <div className={classes.actionBar}>
            <Button variant='contained' color='primary' onClick={openOffer}>
              {label_text || 'Saiba Mais'}
            </Button>
            <Button variant='contained' color='primary' className={classes.moreDetails} onClick={showMoreDetails}>
              {'Saiba Mais'}
            </Button>
          </div>
        </section>
      </section>
      <UpsellModal upsell={props} open={showDetails} onClose={showMoreDetails} onConfirm={openOffer} />
    </Card>
  );
};

export default UpsellCard;
